import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, ResolveFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, Observable, of } from 'rxjs';


export const translateTitle: ResolveFn<string> = (
  route: ActivatedRouteSnapshot
): Observable<string> => {
  const translateService = inject(TranslateService);
  const key = route.data.titleKey;
  if (!key) {
    return of('LiveDOK.Web');
  }
  return translateService.stream(key);
}
